import {useEffect} from 'react';
import {useOutletContext} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {
  createExportedFeature,
  createValueStructureExportedFeatures,
  deleteExportedFeature,
  deleteValueStructureExportedFeatures,
  updateExportedFeature,
  updateValueStructureExportedFeatures,
} from '@actions/admin';
import {getUnderFeatures} from '@actions/agent';
import {Toast} from '@helpers';
import {useDispatchAsync} from '@hooks';

import Table from '../../../../2-components/table/Table';
import checkRequiredFields from '../../../../modules/checkRequiredFields';
import useUpdateData from '../../../../hooks/update-data.hook';

import {config} from './config';

function OwnFeatures() {
  const api = useUpdateData();
  const dispatch = useDispatchAsync();
  const context = useOutletContext();
  const synchronize = context ? context.synchronize : null;
  const underFeatures = useSelector(state => state.agent.underFeatures);
  useEffect(() => {
    config.onSave = async ({next, fieldMustToUpdated}) => {
      for (const {field, value} of fieldMustToUpdated) {
        await api(updateExportedFeature(next.id, field, value));
      }
    };
    config.onCreate = async (idRow, newProduct) => {
      const res = checkRequiredFields(config.fields, newProduct);
      if (!res) {
        return await api(createExportedFeature(newProduct));
      } else {
        Toast.warning('Заповніть обов`язкове поле для введення - ' + res);
      }
      return false;
    };
    config.onDelete = async selectedProduct => {
      await api(deleteExportedFeature(selectedProduct.id));
    };

    config.fields.valueStructure.onSave = async ({
      idRow,
      prev,
      fieldMustToUpdated,
    }) => {
      for (const {field, value} of fieldMustToUpdated) {
        await api(
          updateValueStructureExportedFeatures(idRow, prev.id, field, value)
        );
      }
    };

    config.fields.valueStructure.onCreate = async (idRow, newProduct) => {
      const res = checkRequiredFields(
        config.fields.valueStructure.fields,
        newProduct
      );
      if (!res) {
        return await api(
          createValueStructureExportedFeatures(idRow, newProduct)
        );
      } else {
        Toast.warning('Заповніть обов`язкове поле для введення - ' + res);
      }
      return false;
    };
    config.fields.valueStructure.onDelete = async (selectedProduct, idRow) => {
      await api(deleteValueStructureExportedFeatures(idRow, selectedProduct));
    };
    config.onLoad = async () => {
      await dispatch(getUnderFeatures());
    };
    config.fields.valueStructure.onLoad = async () => {
      await dispatch(getUnderFeatures());
    };
  });

  useEffect(() => {
    dispatch(getUnderFeatures());
  }, []);

  return (
    <div className='OwnFeatures'>
      <Table config={config} data={underFeatures} synchronize={synchronize} />
    </div>
  );
}
export default OwnFeatures;
